import Container, {useTracking as hook} from "./Mixpanel"

export default Container;
export const useTracking = hook;